var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { twMerge } from "tailwind-merge";
import { useFloating, useClick, useDismiss, useRole, useListNavigation, useInteractions, FloatingFocusManager, useTypeahead, offset, size, autoUpdate, FloatingPortal, safePolygon, } from "@floating-ui/react";
import { useHoverLeave } from "./useHoverLeave";
var PopoverMenu = function (_a) {
    var _b = _a.hoverEnabled, hoverEnabled = _b === void 0 ? true : _b, children = _a.children, _c = _a.options, options = _c === void 0 ? [] : _c, _d = _a.placement, placement = _d === void 0 ? "bottom-end" : _d, _e = _a.offsetY, offsetY = _e === void 0 ? 4 : _e, _f = _a.offsetX, offsetX = _f === void 0 ? 0 : _f, contentMinWidth = _a.contentMinWidth, className = _a.className, controlledOpen = _a.open, setControlledOpen = _a.setOpen, props = __rest(_a, ["hoverEnabled", "children", "options", "placement", "offsetY", "offsetX", "contentMinWidth", "className", "open", "setOpen"]);
    var _g = React.useState(false), uncontrolledOpen = _g[0], setUncontrolledOpen = _g[1];
    var _h = React.useState(null), activeIndex = _h[0], setActiveIndex = _h[1];
    var _j = React.useState(-1), selectedIndex = _j[0], setSelectedIndex = _j[1];
    var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    var setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    //   useEffect(() => {
    //     let selected = menuIndex;
    //     if (menuIndex !== defaultLabel && menuIndex?.length > 15) {
    //       selected = "Custom";
    //     }
    //     const index = options.findIndex((user) => user.value === selected);
    //     setSelectedIndex(index);
    //   }, [open, options]);
    //   const [menuIndex, setMenuIndex] = React.useState("");
    var _k = useFloating({
        placement: placement,
        open: open,
        onOpenChange: setOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset({
                mainAxis: offsetY,
                alignmentAxis: offsetX,
                crossAxis: 0,
            }),
            size({
                apply: function (_a) {
                    var rects = _a.rects, elements = _a.elements, availableHeight = _a.availableHeight;
                    Object.assign(elements.floating.style, {
                        maxHeight: "".concat(availableHeight, "px"),
                        minWidth: "".concat(rects.reference.width, "px"),
                    });
                },
                padding: 10,
            }),
        ],
    }), refs = _k.refs, floatingStyles = _k.floatingStyles, context = _k.context;
    var listRef = React.useRef([]);
    var listContentRef = React.useRef(options.map(function (item) { return item.label; }));
    var isTypingRef = React.useRef(false);
    var click = useClick(context, { event: "mousedown" });
    var dismiss = useDismiss(context);
    var role = useRole(context, { role: "listbox" });
    var listNav = useListNavigation(context, {
        listRef: listRef,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        onNavigate: setActiveIndex,
        // This is a large list, allow looping.
        loop: true,
    });
    var typeahead = useTypeahead(context, {
        listRef: listContentRef,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        onMatch: open ? setActiveIndex : setSelectedIndex,
        onTypingChange: function (isTyping) {
            isTypingRef.current = isTyping;
        },
    });
    var hoverLeave = null;
    if (hoverEnabled) {
        hoverLeave = useHoverLeave(context, {
            enabled: true, // only enable hover interactions once open
            handleClose: safePolygon(),
        });
    }
    var _l = useInteractions([dismiss, role, listNav, typeahead, click, hoverLeave]), getReferenceProps = _l.getReferenceProps, getFloatingProps = _l.getFloatingProps, getItemProps = _l.getItemProps;
    return (_jsxs(_Fragment, { children: [React.isValidElement(children) &&
                React.cloneElement(children, getReferenceProps(__assign(__assign(__assign({ ref: refs.setReference }, props), children.props), { "data-state": context.open ? "open" : "closed" }))), open && (_jsx(FloatingPortal, { children: _jsx(FloatingFocusManager, { context: context, modal: false, children: _jsx("div", __assign({ ref: refs.setFloating, className: "z-[99] overflow-y-auto border border-rounded rounded-md border-Silver shadow-lg  min-w-32 text-center bg-white focus:outline-none", role: "group", "aria-orientation": "vertical", "aria-labelledby": "menu-button", tabIndex: "-1", style: floatingStyles }, getFloatingProps(), { children: options.map(function (item, i) { return (_jsx("div", __assign({ className: twMerge("text-gray-700 block text-left text-sm select-none font-semibold ".concat(item.disabled
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"), className), ref: function (node) {
                                listRef.current[i] = node;
                            }, style: {
                                minWidth: contentMinWidth,
                                background: item.disabled
                                    ? "#ffffff"
                                    : i === activeIndex
                                        ? "#F3F3F3"
                                        : selectedIndex === i
                                            ? "#ebebeb"
                                            : "#ffffff",
                            }, role: "menuitem", tabIndex: i === activeIndex ? 0 : -1, "aria-selected": i === selectedIndex && i === activeIndex, "aria-disabled": item.disabled, id: item.value }, getItemProps({
                            // Handle pointer select.
                            onClick: function (e) {
                                if (item.onClick) {
                                    setOpen(false);
                                    item.onClick(item);
                                }
                            },
                            // Handle keyboard select.
                            onKeyDown: function (event) {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    setSelectedIndex(i);
                                    if (item.onClick) {
                                        setOpen(false);
                                        item.onClick(item);
                                    }
                                }
                                if (event.key === " " && !isTypingRef.current) {
                                    event.preventDefault();
                                    setSelectedIndex(i);
                                }
                            },
                        }), { children: item.label }), item.value)); }) })) }) }))] }));
};
export default PopoverMenu;
